








































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import CDLastCommitCard from '@/components/communityDevelopment/CDLastCommitCard.vue'
import {GithubRepositoryCommitCollection} from '@/model/collection/GithubRepositoryCommitCollection'
import _ from 'lodash'

@Component({
  components: {
    CDLastCommitCard,
  },
})
export default class CDLastCommitsSection extends Vue {
  @Prop({type: Number, default: null}) selectedOrganizationId!: number | null
  @Prop({type: String, default: null}) selectedOrganizationName!: string | null

  @Prop({type: Number, default: null}) selectedRepositoryId!: number | null
  @Prop({type: String, default: null}) selectedRepositoryName!: string | null

  @Prop({type: GithubRepositoryCommitCollection, required: true})
  repositoryCommitCollection!: GithubRepositoryCommitCollection

  $refs!: {
    carouselList?: HTMLElement
  }

  get subtitle(): string {
    if (this.selectedOrganizationId === null) {
      return 'Discover the freshest commits in all organizations'
    }

    const org = this.selectedOrganizationName || 'this organization'

    if (this.selectedRepositoryId !== null) {
      const repo = this.selectedRepositoryName || 'this repository'
      return `Discover the freshest commits in ${repo} from ${org}`
    }

    return `Discover the freshest commits in ${org}`
  }

  private async restoreCarouselAndPageScroll(
    pageY: number,
    scrollLeft: number
  ) {
    const apply = () => {
      const list = this.$refs.carouselList
      if (list) {
        list.scrollLeft = scrollLeft
      }
      if (typeof window !== 'undefined') {
        window.scrollTo(0, pageY)
      }
    }

    await this.$nextTick()
    await new Promise<void>(resolve =>
      requestAnimationFrame(() => requestAnimationFrame(() => resolve()))
    )
    apply()
    setTimeout(apply, 50)
  }

  async onExpandClick(expendFn: Function = _.noop) {
    const list = this.$refs.carouselList
    const prevScrollLeft = list?.scrollLeft ?? 0
    const prevPageY =
      typeof window !== 'undefined'
        ? window.pageYOffset || document.documentElement.scrollTop
        : 0

    await expendFn()
    await this.restoreCarouselAndPageScroll(prevPageY, prevScrollLeft)
    this.$emit('viewMoreCommits', this.selectedOrganizationId)
  }
}
